import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Astrology.css';

const Astrology = () => {
  const [expandedSign, setExpandedSign] = useState(null);
  const [expandedTerm, setExpandedTerm] = useState(null);
  const [expandedHouse, setExpandedHouse] = useState(null);

  useEffect(() => {
    document.title = 'Astrologia | Astral Moon Magic';
  }, []);

  // Aurinkomerkit data
  const zodiacSigns = [
    {
      id: 'aries',
      name: 'Oinas',
      nameEn: 'Aries',
      dates: '21.3.–19.4.',
      element: 'Tuli',
      modality: 'Kardinaali',
      symbol: '♈',
      strengths: [
        'Rohkeus ja aloitekyky',
        'Itsenäisyys ja itseluottamus',
        'Suoraviivaisuus ja rehellisyys',
        'Energisyys ja intohimo',
        'Luonnollinen johtajuus'
      ],
      challenges: [
        'Kärsimättömyys ja impulsiivisuus',
        'Aggressiivisuus konflikteissa',
        'Vaikeus keskittyä pitkäjänteisesti',
        'Tendenssi olla itsekäs',
        'Vaikeus hyväksyä kritiikkiä'
      ],
      inLife: 'Oinaana olet luonnollinen pioneeri, joka aloittaa uusia projekteja ja ottaa riskejä. Elämässäsi näkyy vahva halu olla ensimmäinen ja johtaa muita. Sinun energiasi on intensiivistä ja suoraa, mikä tekee sinusta tehokkaan toimijan, mutta joskus myös harkitsemattoman.',
      suitableFor: 'Oinas sopii erityisesti uusien alkuunpanijoiden, yrittäjien ja johtajien oppimiseen. Merkkisi opettaa sinua käyttämään energiaasi rakentavasti ja oppimaan kärsivällisyyttä.'
    },
    {
      id: 'taurus',
      name: 'Härkä',
      nameEn: 'Taurus',
      dates: '20.4.–20.5.',
      element: 'Maa',
      modality: 'Kiinteä',
      symbol: '♉',
      strengths: [
        'Vakaus ja luotettavuus',
        'Kärsivällisyys ja sinnikkyys',
        'Aistillinen nautinto elämästä',
        'Käytännöllisyys ja järkevyys',
        'Vahva tunne turvallisuudesta'
      ],
      challenges: [
        'Tendenssi olla jääräpäinen',
        'Vastustus muutoksille',
        'Materiaalinen kiintymys',
        'Laiskuus ja mukavuudenhalu',
        'Vaikeus antaa periksi'
      ],
      inLife: 'Härkänä arvostat vakautta ja turvallisuutta. Rakennat elämääsi hitaasti mutta varmasti, ja nautit aistillisista nautinnoista. Sinun lähestymistapasi on käytännöllinen ja järkevä, mikä tekee sinusta luotettavan kumppanin ja ystävän.',
      suitableFor: 'Härkä sopii erityisesti taloudenhallinnan, rahoitussuunnittelun ja materiaalisen turvallisuuden oppimiseen. Merkkisi opettaa sinua löytämään tasapainoa turvallisuuden ja muutoksen välillä.'
    },
    {
      id: 'gemini',
      name: 'Kaksoset',
      nameEn: 'Gemini',
      dates: '21.5.–20.6.',
      element: 'Ilma',
      modality: 'Muuttuva',
      symbol: '♊',
      strengths: [
        'Uteliaisuus ja oppimishalu',
        'Sopeutuvaisuus ja monipuolisuus',
        'Nopea ajattelu ja kommunikaatio',
        'Sosiaalisuus ja viehättävyys',
        'Intellektuaalinen ketteryys'
      ],
      challenges: [
        'Pinnallisuus ja keskittymisvaikeudet',
        'Kaksijakoisuus ja epävarmuus',
        'Tendenssi levottomuuteen',
        'Vaikeus sitoutua',
        'Pinnallinen kiinnostus asioihin'
      ],
      inLife: 'Kaksosena olet ikuinen oppija ja kommunikaattori. Elämässäsi näkyy vahva halu kokea uusia asioita ja olla yhteydessä muihin. Sinun mielesi on nopea ja monipuolinen, mikä tekee sinusta mielenkiintoisen keskustelukumppanin.',
      suitableFor: 'Kaksoset sopii erityisesti kommunikaation, median ja monipuolisen oppimisen aloille. Merkkisi opettaa sinua keskittymään ja syventämään tietämystäsi.'
    },
    {
      id: 'cancer',
      name: 'Rapu',
      nameEn: 'Cancer',
      dates: '21.6.–22.7.',
      element: 'Vesi',
      modality: 'Kardinaali',
      symbol: '♋',
      strengths: [
        'Hoivaavuus ja empatia',
        'Intuitio ja tunne-elämä',
        'Perheellisyys ja turvallisuus',
        'Muistot ja perinteet',
        'Suojeluvietti'
      ],
      challenges: [
        'Tunne-elämän vaihtelut',
        'Tendenssi suojautua',
        'Kaipuu turvallisuuteen',
        'Vaikeus päästää irti menneestä',
        'Yliherkkyys kritiikille'
      ],
      inLife: 'Rapuna olet syvästi tunteellinen ja hoivaava. Elämässäsi näkyy vahva tarve turvallisuuteen ja perheeseen. Sinun intuitiosi on vahva, ja tunnet tunteet syvästi, mikä tekee sinusta myötätuntoisen ihmisen.',
      suitableFor: 'Rapu sopii erityisesti perhe-elämän, tunne-elämän ja intuitiivisen kehityksen oppimiseen. Merkkisi opettaa sinua luottamaan tunteisiisi ja löytämään tasapainoa suojelun ja avoimuuden välillä.'
    },
    {
      id: 'leo',
      name: 'Leijona',
      nameEn: 'Leo',
      dates: '23.7.–22.8.',
      element: 'Tuli',
      modality: 'Kiinteä',
      symbol: '♌',
      strengths: [
        'Luovuus ja ilmaisu',
        'Itsevarmuus ja karisma',
        'Ylpeys ja arvokkuus',
        'Anteliaisuus ja lämpö',
        'Luonnollinen johtajuus'
      ],
      challenges: [
        'Ylimielisyys ja ego',
        'Tarve olla huomion keskipisteessä',
        'Vaikeus hyväksyä kritiikkiä',
        'Tendenssi dramatisoida',
        'Yli-itseluottamus'
      ],
      inLife: 'Leijonana olet luova ja karismaattinen. Elämässäsi näkyy vahva halu olla huomion keskipisteessä ja ilmaista itseäsi. Sinun energiasi on lämpimää ja anteliasta, mikä tekee sinusta inspiroivan ihmisen.',
      suitableFor: 'Leijona sopii erityisesti luovuuden, esiintymisen ja johtajuuden oppimiseen. Merkkisi opettaa sinua käyttämään karismaasi rakentavasti ja oppimaan nöyryyttä.'
    },
    {
      id: 'virgo',
      name: 'Neitsyt',
      nameEn: 'Virgo',
      dates: '23.8.–22.9.',
      element: 'Maa',
      modality: 'Muuttuva',
      symbol: '♍',
      strengths: [
        'Analyyttisyys ja järjestelmällisyys',
        'Tarkkuus ja huolellisuus',
        'Palvelualttius ja käytännöllisyys',
        'Kriittinen ajattelu',
        'Terveys- ja hyvinvointitietoisuus'
      ],
      challenges: [
        'Perfektionismi ja kriittisyys',
        'Tendenssi olla liian vaativa',
        'Vaikeus rentoutua',
        'Tendenssi huolehtia liikaa',
        'Vaikeus hyväksyä epätäydellisyyttä'
      ],
      inLife: 'Neitsyenä olet järjestelmällinen ja analyyttinen. Elämässäsi näkyy vahva halu parantaa ja optimoida. Sinun lähestymistapasi on käytännöllinen ja tarkka, mikä tekee sinusta luotettavan työntekijän ja ystävän.',
      suitableFor: 'Neitsyt sopii erityisesti terveyden, järjestelmien optimoinnin ja palvelun oppimiseen. Merkkisi opettaa sinua löytämään tasapainoa perfektionismin ja hyväksymisen välillä.'
    },
    {
      id: 'libra',
      name: 'Vaaka',
      nameEn: 'Libra',
      dates: '23.9.–22.10.',
      element: 'Ilma',
      modality: 'Kardinaali',
      symbol: '♎',
      strengths: [
        'Diplomaattisuus ja tasapaino',
        'Viehätyksenvoima ja kauneus',
        'Yhteistyökyky ja kompromissit',
        'Oikeudenmukaisuus ja harmonia',
        'Sosiaalisuus ja ystävällisyys'
      ],
      challenges: [
        'Päätöksenteon vaikeudet',
        'Tendenssi välttää konflikteja',
        'Riippuvuus muiden mielipiteistä',
        'Vaikeus olla yksin',
        'Tendenssi olla pinnallinen'
      ],
      inLife: 'Vaakana etsit tasapainoa ja harmoniaa kaikessa. Elämässäsi näkyy vahva halu olla yhdessä muiden kanssa ja luoda kaunista. Sinun lähestymistapasi on diplomaattinen ja yhteistyöhaluinen, mikä tekee sinusta suositun kumppanin.',
      suitableFor: 'Vaaka sopii erityisesti suhteiden, taiteen ja oikeudenmukaisuuden oppimiseen. Merkkisi opettaa sinua tekemään päätöksiä ja löytämään oman äänesi.'
    },
    {
      id: 'scorpio',
      name: 'Skorpioni',
      nameEn: 'Scorpio',
      dates: '23.10.–21.11.',
      element: 'Vesi',
      modality: 'Kiinteä',
      symbol: '♏',
      strengths: [
        'Intensiteetti ja intohimo',
        'Syyvyys ja muutoksen kyky',
        'Intuitio ja salaperäisyys',
        'Determinaatio ja voima',
        'Loyaliteetti ja suojeluvietti'
      ],
      challenges: [
        'Mielialojen ääripäät',
        'Tendenssi olla epäluuloinen',
        'Kostonhalu ja mustasukkaisuus',
        'Vaikeus luottaa',
        'Tendenssi olla kontrolloiva'
      ],
      inLife: 'Skorpionina olet intensiivinen ja syvällinen. Elämässäsi näkyy vahva halu ymmärtää elämän salaisuuksia ja muuttua. Sinun energiasi on voimakasta ja muuttumisen kykenevä, mikä tekee sinusta voimakkaan henkilön.',
      suitableFor: 'Skorpioni sopii erityisesti psykologian, muutoksen ja transformaation oppimiseen. Merkkisi opettaa sinua luottamaan ja päästämään irti kontrollista.'
    },
    {
      id: 'sagittarius',
      name: 'Jousimies',
      nameEn: 'Sagittarius',
      dates: '22.11.–21.12.',
      element: 'Tuli',
      modality: 'Muuttuva',
      symbol: '♐',
      strengths: [
        'Optimismi ja iloisuus',
        'Seikkailunhalu ja vapaus',
        'Filosofisuus ja viisaus',
        'Avoimuus ja rehellisyys',
        'Tutkimushenki'
      ],
      challenges: [
        'Tendenssi olla harkitsematon',
        'Vaikeus sitoutua',
        'Tendenssi olla liian suorapuheinen',
        'Levottomuus ja kärsimättömyys',
        'Vaikeus keskittyä yksityiskohtiin'
      ],
      inLife: 'Jousimiehenä olet optimistinen ja seikkailunhaluinen. Elämässäsi näkyy vahva halu tutkia maailmaa ja oppia uutta. Sinun energiasi on vapaata ja iloista, mikä tekee sinusta inspiroivan matkakumppanin.',
      suitableFor: 'Jousimies sopii erityisesti matkustamisen, filosofian ja korkeamman oppimisen aloille. Merkkisi opettaa sinua keskittymään ja sitoutumaan.'
    },
    {
      id: 'capricorn',
      name: 'Kauris',
      nameEn: 'Capricorn',
      dates: '22.12.–19.1.',
      element: 'Maa',
      modality: 'Kardinaali',
      symbol: '♑',
      strengths: [
        'Kunnianhimoisuus ja vastuullisuus',
        'Kurinalaisuus ja sinnikkyys',
        'Käytännöllisyys ja järkevyys',
        'Perinteet ja struktuuri',
        'Pitkäjänteisyys'
      ],
      challenges: [
        'Tendenssi olla liian vakava',
        'Vaikeus rentoutua',
        'Tendenssi olla työnarkomaani',
        'Emotionaalinen pidättyväisyys',
        'Vaikeus antaa periksi'
      ],
      inLife: 'Kauriina olet kunnianhimoinen ja vastuuntuntoinen. Elämässäsi näkyy vahva halu saavuttaa tavoitteesi ja rakentaa kestävää. Sinun lähestymistapasi on järjestelmällinen ja kurinalainen, mikä tekee sinusta luotettavan johtajan.',
      suitableFor: 'Kauris sopii erityisesti uran, johtajuuden ja rakenteiden oppimiseen. Merkkisi opettaa sinua löytämään tasapainoa työn ja elämän välillä.'
    },
    {
      id: 'aquarius',
      name: 'Vesimies',
      nameEn: 'Aquarius',
      dates: '20.1.–18.2.',
      element: 'Ilma',
      modality: 'Kiinteä',
      symbol: '♒',
      strengths: [
        'Itsenäisyys ja omaperäisyys',
        'Innovatiivisuus ja progressiivisuus',
        'Humanitaarisuus ja yhteisöllisyys',
        'Intellektuaalinen ketteryys',
        'Avoimuus uusille ideoille'
      ],
      challenges: [
        'Tendenssi olla etäinen',
        'Vaikeus ilmaista tunteita',
        'Tendenssi olla kapinallinen',
        'Vaikeus sitoutua',
        'Tendenssi olla liian rationaalinen'
      ],
      inLife: 'Vesimiehenä olet itsenäinen ja innovatiivinen. Elämässäsi näkyy vahva halu muuttaa maailmaa ja olla osa yhteisöä. Sinun ajattelusi on progressiivista ja omaperäistä, mikä tekee sinusta inspiroivan ajattelijan.',
      suitableFor: 'Vesimies sopii erityisesti teknologian, innovaation ja yhteisöllisyyden oppimiseen. Merkkisi opettaa sinua ilmaisemaan tunteitasi ja sitoutumaan.'
    },
    {
      id: 'pisces',
      name: 'Kalat',
      nameEn: 'Pisces',
      dates: '19.2.–20.3.',
      element: 'Vesi',
      modality: 'Muuttuva',
      symbol: '♓',
      strengths: [
        'Empatia ja myötätunto',
        'Intuitio ja psyykkinen kyky',
        'Luovuus ja taiteellisuus',
        'Unelmoivuus ja idealismi',
        'Henkisyys ja mystisyys'
      ],
      challenges: [
        'Tendenssi olla liian herkkä',
        'Vaikeus asettaa rajoja',
        'Tendenssi pakenea todellisuutta',
        'Vaikeus olla käytännöllinen',
        'Tendenssi olla liian idealistinen'
      ],
      inLife: 'Kalana olet herkkä ja intuitiivinen. Elämässäsi näkyy vahva halu auttaa muita ja ymmärtää elämän syvempiä merkityksiä. Sinun energiasi on unelmoivaa ja taiteellista, mikä tekee sinusta inspiroivan henkilön.',
      suitableFor: 'Kalat sopii erityisesti taiteen, henkisyyden ja empatian oppimiseen. Merkkisi opettaa sinua asettamaan rajoja ja olemaan käytännöllisempi.'
    }
  ];

  // Tukevat käsitteet
  const basicConcepts = [
    {
      id: 'sun-sign',
      term: 'Aurinkomerkki',
      description: (
        <div>
          <p><strong>Mikä aurinkomerkki on?</strong> Aurinkomerkki on se merkki, jossa Aurinko oli syntymähetkelläsi. Se kuvaa perusidentiteettiäsi, elämänvoimaasi ja sitä, miten ilmennät itseäsi maailmalle. Aurinkomerkki on usein se, mitä ihmiset tuntevat "horoskooppimerkkinä".</p>
          <p><strong>Miten se eroaa kuumerkistä ja nousumerkistä?</strong> Aurinkomerkki kuvaa ydintäsi ja sitä, kuka olet syvimmällä tasolla. Kuumerkki puolestaan kertoo tunne-elämästäsi ja siitä, miten reagoit maailmaan. Nousumerkki näyttää, miten muut näkevät sinut ja miten lähestyt uusia tilanteita. Yhdessä nämä kolme muodostavat "Big Three" -kombinaation, joka antaa kattavan kuvan persoonallisuudestasi.</p>
          <p><strong>Yleinen harhaluulo:</strong> Monet ajattelevat, että "olen vain tämä merkki", mutta todellisuudessa syntymäkarttasi sisältää paljon enemmän. Aurinkomerkki on tärkeä osa, mutta se ei määritä sinua kokonaan. Sama aurinkomerkki voi näkyä eri tavoin riippuen muista planeetoista, huoneista ja aspekteista kartallasi.</p>
          <p><strong>Miten sitä luetaan kartalla?</strong> Etsi kartastasi Auringon symboli (☉) ja katso, missä merkissä se on. Jos Aurinko on esimerkiksi Oinaassa, sinun aurinkomerkkisi on Oinas. Tämä kertoo, että identiteettisi ja elämänvoimasi ovat oinaan energian mukaisia: rohkeita, aloitekykyisiä ja itsenäisiä.</p>
        </div>
      )
    },
    {
      id: 'moon-sign',
      term: 'Kuumerkki',
      description: (
        <div>
          <p><strong>Mikä kuumerkki on?</strong> Kuumerkki on se merkki, jossa Kuu oli syntymähetkelläsi. Se kuvaa tunne-elämääsi, vaistojasi ja alitajuisia tarpeitasi. Kuumerkki paljastaa, miten reagoit emotionaalisesti ja mitä tarvitset turvallisuuteen ja mukavuuteen.</p>
          <p><strong>Tunne-elämä ja reaktiot:</strong> Kuumerkki kertoo, miten käsittelet tunteitasi ja miten reagoit maailmaan. Se on "sydämesi" ja paljastaa, mitä tarvitset emotionaalisesti. Esimerkiksi Kuu Rapussa tarvitsee turvallisuutta ja perhettä, kun taas Kuu Leijonassa tarvitsee tunnustusta ja huomiota.</p>
          <p><strong>Miten näkyy ihmissuhteissa ja arjessa:</strong> Kuumerkki näkyy siinä, miten koet turvallisuuden, miten reagoit stressiin ja miten hoidat itseäsi. Se vaikuttaa myös siihen, miten koet perheen ja läheiset suhteet. Kuumerkki on usein se osa sinua, jota et aina näytä muille, mutta joka vaikuttaa syvästi käyttäytymiseesi.</p>
          <p><strong>Vinkki: miten työstää kuun teemoja käytännössä:</strong> Tunnista, mitä tarvitset emotionaalisesti (turvallisuus, rakkaus, itsenäisyys jne.) ja luo olosuhteet, joissa nämä tarpeet täyttyvät. Harjoittele tunteiden tunnistamista ja ilmaisua. Muista, että kuumerkki on osa sinua, jota ei tarvitse piilottaa, vaan hyväksyä ja työstää.</p>
        </div>
      )
    },
    {
      id: 'rising-sign',
      term: 'Nousumerkki (Ascendant)',
      description: (
        <div>
          <p><strong>Mikä nousumerkki on?</strong> Nousumerkki (Ascendant) on se merkki, joka nousee horisontin yläpuolelle tarkalla syntymähetkelläsi ja -paikallasi. Se kuvaa sitä, miten muut näkevät sinut ja miten lähestyt maailmaa. Nousumerkki on "maskisi" tai "ikkunasi" maailmaan – se on ensimmäinen vaikutelma, jonka annat.</p>
          <p><strong>Miksi syntymäaika on tärkeä?</strong> Koska maapallo pyörii, horisontti nousee eri merkit eri aikoina. Tarkka syntymäaika määrittää, mikä merkki oli juuri nousevassa horisontissa sinun syntymähetkelläsi. Vain muutaman minuutin ero voi muuttaa nousumerkkisi, mikä tekee tarkasta ajasta kriittisen.</p>
          <p><strong>Miten nousu vaikuttaa huoneiden järjestykseen?</strong> Nousumerkki määrittää 1. huoneen alkuperän. Jos nousumerkkisi on esimerkiksi Leijona, 1. huone alkaa Leijonasta. Tämä tarkoittaa, että kaikki huoneet järjestetään nousumerkistä lähtien. Jos nousumerkkisi on Leijona, 2. huone on Neitsyt, 3. huone on Vaaka, ja niin edelleen. Tämä tekee nousumerkistä perustan koko kartan rakenteelle.</p>
          <p><strong>Käytännössä:</strong> Nousumerkki näkyy usein ulkoisessa ilmeessäsi, käyttäytymisessäsi uusissa tilanteissa ja siinä, miten muut kokevat sinut ensi kertaa. Se on "julkisivusi", kun taas aurinkomerkki on "sydämesi" ja kuumerkki "tunne-elämäsi".</p>
        </div>
      )
    },
    {
      id: 'planets',
      term: 'Planeetat',
      description: (
        <div>
          <p><strong>Jaottelu planeetoihin:</strong> Planeetat jaetaan kolmeen ryhmään. <strong>Persoonalliset planeetat</strong> (Aurinko, Kuu, Merkurius, Venus, Mars) liittyvät henkilökohtaiseen elämään ja päivittäisiin asioihin. <strong>Sosiaaliset planeetat</strong> (Jupiter, Saturnus) liittyvät yhteiskuntaan ja laajempiin rakenteisiin. <strong>Transpersoonalliset planeetat</strong> (Uranus, Neptunus, Pluto) liittyvät sukupolvien ja yhteisöjen kokemuksiin.</p>
          <p><strong>Mikä tarkoittaa planeetta merkissä vs huoneessa:</strong> Kun planeetta on tietyssä merkissä, se kertoo <em>miten</em> se ilmenee (tyyli). Esimerkiksi Mars Oinaassa on suora ja impulsiivinen. Kun planeetta on tietyssä huoneessa, se kertoo <em>missä</em> elämässäsi se ilmenee (elämänalue). Esimerkiksi Mars 7. huoneessa näkyy suhteissa ja konflikteissa.</p>
          <p><strong>Esimerkkirakenne: "Venus Vaaka 7. huoneessa":</strong> Tämä tarkoittaa, että Venus (rakkaus, kauneus, arvot) on Vaakassa (diplomaattinen, tasapainoinen tyyli) 7. huoneessa (suhteet, kumppanuus). Käytännössä tämä voi tarkoittaa, että etsit tasapainoista ja kaunista kumppanuutta, arvostat diplomaattisuutta suhteissa ja haluat harmonian ihmissuhteisiin. Rakkautesi ilmenee suhteissa (7. huone) diplomaattisena ja tasapainoisena (Vaaka).</p>
        </div>
      )
    },
    {
      id: 'elements',
      term: 'Elementit ja Modaliteetit',
      description: (
        <div>
          <p><strong>4 elementtiä: miten ne ilmenevät käyttäytymisenä:</strong> <strong>Tuli</strong> (Oinas, Leijona, Jousimies) on energistä, intohimoista ja spontaania. Tulimerkit toimivat nopeasti ja haluavat olla ensimmäisiä. <strong>Maa</strong> (Härkä, Neitsyt, Kauris) on vakaa, käytännöllinen ja maanläheinen. Maamerkit rakentavat hitaasti mutta varmasti. <strong>Ilma</strong> (Kaksoset, Vaaka, Vesimies) on intellektuaalista, sosiaalista ja kommunikatiivista. Ilmamerkit ajattelevat ja keskustelevat. <strong>Vesi</strong> (Rapu, Skorpioni, Kalat) on tunteellista, intuitiivista ja syvällistä. Vesimerkit tuntevat syvästi ja reagoivat emotionaalisesti.</p>
          <p><strong>3 modaliteettia: miten toiminta käynnistyy ja jatkuu:</strong> <strong>Kardinaali</strong> (Oinas, Rapu, Vaaka, Kauris) aloittaa ja käynnistää. Nämä merkit ottavat aloitteen ja aloittavat uusia projekteja. <strong>Kiinteä</strong> (Härkä, Leijona, Skorpioni, Vesimies) ylläpitää ja rakentaa. Nämä merkit jatkavat aloitettua ja rakentavat kestävää. <strong>Muuttuva</strong> (Kaksoset, Neitsyt, Jousimies, Kalat) sopeutuu ja muuttaa. Nämä merkit joustavat ja sopeutuvat muuttuviin olosuhteisiin.</p>
          <p><strong>Tasapaino ja ylikorostuminen:</strong> Ihanteellisessa kartassa on tasapaino kaikista elementeistä ja modaliteeteista. Jos jokin elementti puuttuu kokonaan, se voi aiheuttaa haasteita. Esimerkiksi ilman Tulielementtiä voi puuttua energia ja aloitekyky. Ilman Maaelementtiä voi olla vaikea olla käytännöllinen. Ylikorostunut elementti voi aiheuttaa epätasapainoa. Esimerkiksi liikaa Vettä voi tehdä liian tunteelliseksi, liikaa Ilmaa liian ajattelevaksi ilman tunnetta.</p>
        </div>
      )
    },
    {
      id: 'aspects',
      term: 'Aspektit',
      description: (
        <div>
          <p><strong>Määritelmä: planeettojen kulmasuhde:</strong> Aspektit ovat kulmia planeettojen välillä syntymäkartassa. Ne kuvaavat, miten eri energiat vuorovaikuttavat keskenään. Aspektit muodostuvat, kun planeetat ovat tietyssä kulmassa toisiinsa nähden (esim. 0°, 60°, 90°, 120°, 180°).</p>
          <p><strong>Helpot vs haastavat aspektit:</strong> <strong>Helpot aspektit</strong> (Sekstiili 60°, Kolmio 120°) luovat harmonian ja yhteistyön. Energiat virtaavat sujuvasti. <strong>Haastavat aspektit</strong> (Neliö 90°, Oppositio 180°) luovat jännitteitä ja haasteita. Ne vaativat työtä, mutta antavat myös voimaa ja kasvua. <strong>Konjunktio</strong> (0°) yhdistää energiat voimakkaasti - se voi olla joko helpompi tai haastavampi riippuen planeetoista.</p>
          <p><strong>Mitä ne "tuntuvat" käytännössä:</strong> <strong>Konjunktio</strong> tuntuu intensiiviseltä ja voimakkaalta - energiat yhdistyvät. <strong>Sekstiili</strong> tuntuu mahdollisuuksilta ja yhteistyöltä - asiat tapahtuvat helposti. <strong>Neliö</strong> tuntuu jännitteeltä ja haasteelta - tarvitaan työtä, mutta se antaa voimaa. <strong>Kolmio</strong> tuntuu harmoniselta ja sujuvilta - energiat virtaavat luonnollisesti. <strong>Oppositio</strong> tuntuu vastakkaisuudelta ja tasapainon haulta - tarvitaan kompromisseja.</p>
        </div>
      )
    },
    {
      id: 'natal-chart',
      term: 'Syntymäkartta (Natal Chart)',
      description: (
        <div>
          <p><strong>Mitä tietoja tarvitaan:</strong> Tarkka syntymäkartta vaatii kolme tärkeää tietoa: <strong>syntymäpäivä</strong> (päivä, kuukausi, vuosi), <strong>tarkka syntymäaika</strong> (kellonaika, mieluiten minuutin tarkkuudella) ja <strong>syntymäpaikka</strong> (kaupunki ja maa). Nämä kolme määrittävät kaikkien planeettojen tarkan sijainnin, nousumerkin ja huoneiden järjestyksen.</p>
          <p><strong>Miksi kellonaika vaikuttaa nousuun ja huoneisiin:</strong> Koska maapallo pyörii, horisontti nousee eri merkit eri aikoina. Tarkka kellonaika määrittää, mikä merkki oli juuri nousevassa horisontissa (nousumerkki). Nousumerkki puolestaan määrittää 1. huoneen alkuperän, ja kaikki muut huoneet järjestetään siitä lähtien. Vain muutaman minuutin ero voi muuttaa nousumerkkisi ja koko huoneiden järjestyksen.</p>
          <p><strong>Miten lukea karttaa: 3 askelta:</strong> <strong>1) Planeetta → merkki:</strong> Katso missä merkissä jokainen planeetta on. Tämä kertoo <em>miten</em> energia ilmenee. <strong>2) Planeetta → huone:</strong> Katso missä huoneessa planeetta on. Tämä kertoo <em>missä</em> elämässäsi energia näkyy. <strong>3) Aspektit:</strong> Katso miten planeetat vuorovaikuttavat keskenään. Tämä kertoo <em>miten</em> eri energiat yhdistyvät tai jännittävät. Yhdessä nämä kolme antavat täyden kuvan persoonallisuudestasi ja elämästäsi.</p>
        </div>
      )
    }
  ];

  // Huoneet
  const houses = [
    { 
      number: 1, 
      name: 'Minä / Identiteetti', 
      description: 'Kuvaa minäkuvaasi, ulkoista ilmeesi ja sitä, miten aloitat asioita. Tämä on "nousumerkin talo".',
      detailedContent: {
        keywords: ['Identiteetti', 'Minäkuva', 'Ulkoinen ilme', 'Aloitekyky', 'Energia', 'Fyysinen olemus', 'Ensivaikutelma', 'Itsensä ilmaisu'],
        theme: '1. huone on sinun identiteettisi ja minäkuvasi. Se kuvaa sitä, miten näytät itsesi maailmalle ja miten aloitat uusia asioita. Tämä on "nousumerkin talo", mikä tarkoittaa, että nousumerkkisi määrittää tämän huoneen alkuperän.',
        whenEmphasized: [
          'Olet vahvasti tietoinen itsestäsi ja identiteetistäsi',
          'Ulkoinen ilmeesi on selkeä ja vahva',
          'Aloitat asioita helposti ja energisesti',
          'Muut huomaavat sinut heti uusissa tilanteissa',
          'Fyysinen olemuksesi on tärkeä osa identiteettiäsi'
        ],
        challenges: [
          'Tendenssi olla liian itsekeskeinen',
          'Vaikeus nähdä itseäsi objektiivisesti',
          'Yli-identifioituminen ulkoiseen kuvaan',
          'Vaikeus muuttaa ensivaikutelmaa',
          'Tendenssi unohtaa muut kun keskittyy itseensä'
        ],
        practicalTips: [
          'Harjoittele itsetuntemusta ja kysy itseltäsi: "Kuka olen todella?"',
          'Ole tietoinen siitä, miten muut näkevät sinut, mutta älä anna sen määritellä sinua',
          'Käytä 1. huoneen energiaa aloittamaan uusia projekteja ja kehittämään itseäsi'
        ],
        selfReflection: [
          'Miten näytän itseni maailmalle?',
          'Mikä on minun identiteettini?',
          'Miten aloitan uusia asioita?',
          'Miten muut näkevät minut ensi kertaa?'
        ]
      }
    },
    { 
      number: 2, 
      name: 'Raha / Arvot', 
      description: 'Liittyy talouteesi, materiaalisiin resursseihin, arvoihisi ja itsetuntoosi.',
      detailedContent: {
        keywords: ['Raha', 'Talous', 'Materiaaliset resurssit', 'Arvot', 'Itsetunto', 'Omistaminen', 'Turvallisuus', 'Aistillisuus'],
        theme: '2. huone liittyy talouteesi, materiaalisiin resursseihin ja arvoihisi. Se kertoo, miten suhtaudut rahaan, omistamiseen ja aistillisiin nautintoihin. Tämä huone myös paljastaa, mitä arvostat elämässäsi ja miten rakennat itsetuntoasi.',
        whenEmphasized: [
          'Raha ja materiaaliset resurssit ovat tärkeitä elämässäsi',
          'Arvostat korkealaatuisia asioita ja kestävyyttä',
          'Itsetuntosi liittyy vahvasti materiaaliseen turvallisuuteen',
          'Nautit aistillisista iloista (ruoka, kosketus, kauneus)',
          'Rakennat elämääsi hitaasti mutta varmasti'
        ],
        challenges: [
          'Tendenssi olla liian materialistinen',
          'Vaikeus jakaa resursseja muille',
          'Yli-kiintymys materiaalisiin asioihin',
          'Vaikeus muuttaa taloudellisia tapoja',
          'Tendenssi mitata arvoa vain rahalla'
        ],
        practicalTips: [
          'Tutki, mitä todella arvostat elämässäsi (ei vain materiaalisia asioita)',
          'Rakenna terve suhde rahaan: se on työkalu, ei tavoite',
          'Harjoittele antamista ja jakamista, jotta raha ei määritä sinua'
        ],
        selfReflection: [
          'Mikä on minun suhtautumiseni rahaan?',
          'Mitkä ovat minun todelliset arvoni?',
          'Miten rakennan itsetuntoani?',
          'Mitä tarvitsen ollakseni turvallinen?'
        ]
      }
    },
    { 
      number: 3, 
      name: 'Kommunikaatio', 
      description: 'Kuvaa kommunikaatiotasi, oppimistasi, lähiympäristöäsi ja veljien/siskojen suhteita.',
      detailedContent: {
        keywords: ['Kommunikaatio', 'Oppiminen', 'Lähiympäristö', 'Veljet/Sisarukset', 'Kirjoittaminen', 'Puhuminen', 'Koulutus', 'Uteliaisuus'],
        theme: '3. huone liittyy kommunikaatioon, oppimiseen ja lähiympäristöösi. Se kertoo, miten ilmaiset itseäsi, miten opit uutta ja miten suhtaudut veljiin/sisaruksiin. Tämä huone myös paljastaa, miten koet lähiympäristösi ja miten liikut siinä.',
        whenEmphasized: [
          'Olet luonnollinen kommunikaattori ja oppija',
          'Lähiympäristösi on tärkeä osa elämääsi',
          'Veljet/sisarukset ovat merkittäviä suhteitasi',
          'Nautit oppimisesta ja tiedon jakamisesta',
          'Kirjoittaminen ja puhuminen ovat vahvuuksiasi'
        ],
        challenges: [
          'Tendenssi olla liian puhelias tai levoton',
          'Vaikeus keskittyä yhteen asiaan kerrallaan',
          'Pinnallinen kiinnostus moniin asioihin',
          'Vaikeus syventää tietämystä',
          'Tendenssi levottomuuteen ja hajautuneisuuteen'
        ],
        practicalTips: [
          'Harjoittele aktiivista kuuntelua, ei vain puhumista',
          'Syvennä tietämystäsi muutamassa aiheessa sen sijaan että pysyt pinnallisena',
          'Käytä kommunikaatiotaitojasi rakentavasti ja auta muita oppimaan'
        ],
        selfReflection: [
          'Miten kommunikoin muiden kanssa?',
          'Miten opit parhaiten?',
          'Mikä on minun suhteeni veljiin/sisaruksiin?',
          'Miten koen lähiympäristöni?'
        ]
      }
    },
    { 
      number: 4, 
      name: 'Koti / Juuret', 
      description: 'Liittyy kotiisi, perheeseesi, juuriisi ja tunneperustaasi. Tämä on "kodin talo".',
      detailedContent: {
        keywords: ['Koti', 'Perhe', 'Juuret', 'Tunneperusta', 'Yksityisyys', 'Turvallisuus', 'Perintö', 'Sisäinen maailma'],
        theme: '4. huone liittyy kotiisi, perheeseesi ja juuriisi. Se kertoo, miten koet turvallisuuden ja minkälaiset perhesuhteet sinulla on. Tämä on "kodin talo" ja se paljastaa, mitä tarvitset ollaksesi turvassa ja miten rakennat perustasi.',
        whenEmphasized: [
          'Koti ja perhe ovat keskeisiä elämässäsi',
          'Arvostat yksityisyyttä ja omaa tilaa',
          'Perhesuhteet vaikuttavat vahvasti sinuun',
          'Tarvitset turvallisen perustan elämällesi',
          'Juuresi ja perintö ovat tärkeitä'
        ],
        challenges: [
          'Tendenssi olla liian sulkeutunut',
          'Vaikeus päästää irti perheestä',
          'Yli-kiintymys kotiin ja turvallisuuteen',
          'Vaikeus muuttaa tai muuttua',
          'Tendenssi elää menneisyydessä'
        ],
        practicalTips: [
          'Rakenna terve perheperusta, mutta älä anna sen määritellä sinua',
          'Luo koti, joka on turvallinen mutta ei vangitse sinua',
          'Tutki perheesi perintöä ja sen vaikutusta sinuun'
        ],
        selfReflection: [
          'Mikä on minun käsitykseni kodista?',
          'Miten perheeni vaikuttaa minuun?',
          'Mitä tarvitsen ollakseni turvassa?',
          'Miten rakennan perustani?'
        ]
      }
    },
    { 
      number: 5, 
      name: 'Luovuus', 
      description: 'Kuvaa luovuuttasi, romantiikkaa, lapsia, viihdettä ja ilmaisua.',
      detailedContent: {
        keywords: ['Luovuus', 'Romantiikka', 'Lapset', 'Viihde', 'Ilmaisu', 'Rakkaus', 'Harrastukset', 'Ilo'],
        theme: '5. huone liittyy luovuuteesi, romantiikkaan, lapsiin ja viihdykkeeseen. Se kertoo, miten ilmaiset itseäsi, miten nautit elämästä ja miten suhtaudut rakkauteseen ja romantiikkaan. Tämä huone myös paljastaa suhteesi lapsiin ja harrastuksiin.',
        whenEmphasized: [
          'Luovuus ja ilmaisu ovat tärkeitä elämässäsi',
          'Nautit romantiikasta ja rakkaudesta',
          'Lapset ja nuoret ovat merkittäviä elämässäsi',
          'Harrastukset ja viihde antavat energiaa',
          'Olet luova ja iloinen henkilö'
        ],
        challenges: [
          'Tendenssi olla liian kevytmielinen',
          'Vaikeus ottaa vastuuta',
          'Tendenssi välttää vakavia asioita',
          'Vaikeus sitoutua',
          'Yli-optimismi ja realismin puute'
        ],
        practicalTips: [
          'Käytä luovuuttasi rakentavasti ja ilmaise itseäsi',
          'Löydä tasapaino ilon ja vastuun välillä',
          'Rakasta ja nauti, mutta älä unohda vakavia asioita'
        ],
        selfReflection: [
          'Miten ilmaisen luovuuttani?',
          'Mikä on minun suhteeni rakkauteseen?',
          'Miten koen lapset ja nuoret?',
          'Mitä harrastuksia nautin?'
        ]
      }
    },
    { 
      number: 6, 
      name: 'Työ / Terveys', 
      description: 'Liittyy päivittäiseen työhösi, terveyteesi, rutiineihisi ja palveluun.',
      detailedContent: {
        keywords: ['Työ', 'Terveys', 'Rutiinit', 'Palvelu', 'Päivittäisyys', 'Kurinalaisuus', 'Hyvinvointi', 'Ahkeruus'],
        theme: '6. huone liittyy päivittäiseen työhösi, terveyteesi, rutiineihisi ja palveluun. Se kertoo, miten suhtaudut työhön, miten huolehdit terveydestäsi ja miten rakennat rutiineja. Tämä huone myös paljastaa, miten palvelet muita ja miten koet päivittäisen elämän.',
        whenEmphasized: [
          'Työ ja rutiinit ovat tärkeitä elämässäsi',
          'Terveys ja hyvinvointi ovat prioriteetteja',
          'Olet ahkera ja kurinalainen',
          'Palvelet muita mielelläsi',
          'Rakennat kestävää päivittäistä elämää'
        ],
        challenges: [
          'Tendenssi olla työnarkomaani',
          'Vaikeus rentoutua',
          'Yli-huolehtiminen terveydestä',
          'Vaikeus sanoa ei',
          'Tendenssi unohtaa itsensä palvellessa muita'
        ],
        practicalTips: [
          'Löydä tasapaino työn ja lepon välillä',
          'Rakenna terveet rutiinit, mutta älä anna niiden hallita sinua',
          'Palvele muita, mutta muista myös itsesi'
        ],
        selfReflection: [
          'Mikä on minun suhteeni työhön?',
          'Miten huolehdin terveydestäni?',
          'Miten rakennan rutiinejani?',
          'Miten palvelen muita?'
        ]
      }
    },
    { 
      number: 7, 
      name: 'Suhteet', 
      description: 'Kuvaa kumppanuuksiasi, avioliittoa ja läheisiä ihmissuhteitasi. Tämä on "kumppanuuden talo".',
      detailedContent: {
        keywords: ['Suhteet', 'Kumppanuus', 'Avioliitto', 'Yhteistyö', 'Diplomatia', 'Tasapaino', 'Yhteensopivuus', 'Kumppani'],
        theme: '7. huone liittyy kumppanuuksiin, avioliittoon ja läheisiin ihmissuhteisiin. Se kertoo, miten suhtaudut kumppanuuteen, mitä etsit suhteesta ja miten toimii yhteistyössä. Tämä on "kumppanuuden talo" ja se paljastaa, millainen kumppani olet.',
        whenEmphasized: [
          'Kumppanuudet ja suhteet ovat keskeisiä elämässäsi',
          'Etsit tasapainoa ja harmoniaa suhteissa',
          'Olet yhteistyökykyinen ja diplomaattinen',
          'Arvostat kumppanuutta ja yhteistyötä',
          'Suhteet vaikuttavat vahvasti elämääsi'
        ],
        challenges: [
          'Tendenssi olla liian riippuvainen kumppanista',
          'Vaikeus olla yksin',
          'Tendenssi välttää konflikteja',
          'Vaikeus tehdä päätöksiä ilman kumppania',
          'Yli-idealistinen suhtautuminen suhteisiin'
        ],
        practicalTips: [
          'Rakenna terveitä suhteita, mutta säilytä myös itsenäisyytesi',
          'Opi kommunikoimaan avoimesti konflikteista',
          'Löydä tasapaino yhteistyön ja itsenäisyyden välillä'
        ],
        selfReflection: [
          'Mikä on minun suhteeni kumppanuuteen?',
          'Mitä etsin suhteesta?',
          'Miten toimii yhteistyössä?',
          'Miten koen läheiset ihmissuhteet?'
        ]
      }
    },
    { 
      number: 8, 
      name: 'Intiimiys / Muutos', 
      description: 'Liittyy transformaatioon, jaettuihin resursseihin, syvällisiin asioihin ja uudelleensyntymiseen.',
      detailedContent: {
        keywords: ['Intiimiys', 'Muutos', 'Transformaatio', 'Jaetut resurssit', 'Syyvyys', 'Psykologia', 'Uudelleensyntyminen', 'Salaisuudet'],
        theme: '8. huone liittyy transformaatioon, intiimiyteen, jaettuihin resursseihin ja syvällisiin asioihin. Se kertoo, miten käsittelet muutosta, miten suhtaudut intiimiyteen ja miten jakat resursseja. Tämä huone myös paljastaa suhteesi syvällisiin asioihin ja psykologiaan.',
        whenEmphasized: [
          'Muutos ja transformaatio ovat keskeisiä elämässäsi',
          'Intiimiys ja syvyys ovat tärkeitä',
          'Olet kiinnostunut psykologiasta ja salaisuuksista',
          'Jaetut resurssit (raha, energia) ovat merkittäviä',
          'Uudelleensyntyminen ja muutos ovat osa elämääsi'
        ],
        challenges: [
          'Tendenssi olla liian intensiivinen',
          'Vaikeus luottaa ja jakaa',
          'Tendenssi olla mustasukkainen',
          'Vaikeus päästää irti kontrollista',
          'Yli-syvyys ja vaikeus olla kevytmielinen'
        ],
        practicalTips: [
          'Hyväksy muutos osana elämää, mutta älä anna sen määritellä sinua',
          'Rakenna terve suhde intiimiyteen ja jaettuihin resursseihin',
          'Käytä transformaatiota rakentavasti'
        ],
        selfReflection: [
          'Miten käsittelen muutosta?',
          'Mikä on minun suhteeni intiimiyteen?',
          'Miten jakat resursseja?',
          'Mitä syvällisiä asioita kiinnostaa minua?'
        ]
      }
    },
    { 
      number: 9, 
      name: 'Uskomukset / Opiskelu / Matkat', 
      description: 'Kuvaa filosofiasi, korkeampaa oppimista, matkustamista ja laajempaa maailmankuvaasi.',
      detailedContent: {
        keywords: ['Uskomukset', 'Filosofia', 'Opiskelu', 'Matkat', 'Laajempi maailmankuva', 'Viisaus', 'Korkeampi oppiminen', 'Tutkimus'],
        theme: '9. huone liittyy uskomuksiin, filosofiin, korkeampaan oppimiseen ja matkustamiseen. Se kertoo, miten näet maailman, mitä uskot ja miten opit. Tämä huone myös paljastaa suhteesi matkustamiseen ja laajempaan maailmankuvaan.',
        whenEmphasized: [
          'Filosofia ja uskomukset ovat tärkeitä elämässäsi',
          'Korkeampi oppiminen ja opiskelu inspiroivat sinua',
          'Matkustaminen laajentaa maailmankuvaasi',
          'Etsit totuutta ja viisautta',
          'Laajempi maailmankuva on merkittävä'
        ],
        challenges: [
          'Tendenssi olla liian idealistinen',
          'Vaikeus sovittaa uskomuksia käytäntöön',
          'Tendenssi pakenea todellisuutta',
          'Vaikeus keskittyä yksityiskohtiin',
          'Yli-filosofisuus ja vaikeus olla käytännöllinen'
        ],
        practicalTips: [
          'Rakenna uskomukset, mutta sovita ne käytäntöön',
          'Opiskele ja matkusta, mutta älä unohda arkea',
          'Etsi totuutta, mutta hyväksy myös epävarmuus'
        ],
        selfReflection: [
          'Mitkä ovat minun uskomukseni?',
          'Miten opit parhaiten?',
          'Mikä on minun suhteeni matkustamiseen?',
          'Miten näen maailman?'
        ]
      }
    },
    { 
      number: 10, 
      name: 'Ura / Julkisuus', 
      description: 'Liittyy uraasi, julkiseen kuvaasi, maineeseesi ja elämäntehtävääsi. Tämä on "uran talo".',
      detailedContent: {
        keywords: ['Ura', 'Julkisuus', 'Maine', 'Elämäntehtävä', 'Asema', 'Kunnia', 'Vastuu', 'Johtajuus'],
        theme: '10. huone liittyy uraasi, julkiseen kuvaasi, maineeseesi ja elämäntehtävääsi. Se kertoo, miten koet uran, mitä haluat saavuttaa ja miten muut näkevät sinut julkisesti. Tämä on "uran talo" ja se paljastaa elämäntehtäväsi.',
        whenEmphasized: [
          'Ura ja julkisuus ovat keskeisiä elämässäsi',
          'Haluat saavuttaa ja rakentaa mainetta',
          'Elämäntehtäväsi on selkeä',
          'Olet kunnianhimoinen ja vastuuntuntoinen',
          'Julkinen kuva on tärkeä'
        ],
        challenges: [
          'Tendenssi olla työnarkomaani',
          'Vaikeus löytää tasapainoa työn ja elämän välillä',
          'Yli-kunnianhimoisuus',
          'Vaikeus rentoutua',
          'Tendenssi mitata arvoa vain uralla'
        ],
        practicalTips: [
          'Rakenna ura, mutta älä unohda muita elämän osa-alueita',
          'Löydä tasapaino julkisen kuvan ja yksityisyyden välillä',
          'Tunnista elämäntehtäväsi, mutta älä anna sen määritellä sinua'
        ],
        selfReflection: [
          'Mikä on minun elämäntehtäväni?',
          'Miten koen uran?',
          'Mikä on minun julkisen kuvani?',
          'Mitä haluan saavuttaa?'
        ]
      }
    },
    { 
      number: 11, 
      name: 'Yhteisöt / Tulevaisuus', 
      description: 'Kuvaa ystävyyssuhteitasi, toiveitasi, sosiaalisia ryhmiäsi ja tulevaisuuden visioitasi.',
      detailedContent: {
        keywords: ['Yhteisöt', 'Ystävyys', 'Toiveet', 'Tulevaisuus', 'Sosiaaliset ryhmät', 'Yhteisöllisyys', 'Visiot', 'Yhteistyö'],
        theme: '11. huone liittyy yhteisöihin, ystävyyssuhteisiin, toiveisiin ja tulevaisuuden visioihin. Se kertoo, miten koet yhteisöt, mitä toiveita sinulla on ja miten näet tulevaisuuden. Tämä huone myös paljastaa suhteesi sosiaalisiin ryhmiin ja yhteisöllisyyteen.',
        whenEmphasized: [
          'Yhteisöt ja ystävyyssuhteet ovat tärkeitä elämässäsi',
          'Toiveet ja visiot inspiroivat sinua',
          'Olet yhteisöllinen ja sosiaalinen',
          'Tulevaisuus ja muutos ovat merkittäviä',
          'Sosiaaliset ryhmät antavat energiaa'
        ],
        challenges: [
          'Tendenssi olla liian riippuvainen yhteisöstä',
          'Vaikeus olla yksin',
          'Yli-idealistiset toiveet',
          'Vaikeus toteuttaa visioita',
          'Tendenssi unohtaa yksilöllisyys yhteisön hyväksi'
        ],
        practicalTips: [
          'Rakenna yhteisöjä, mutta säilytä myös itsenäisyytesi',
          'Toteuta toiveitasi, mutta ole myös realistinen',
          'Käytä yhteisöllisyyttä rakentavasti'
        ],
        selfReflection: [
          'Mikä on minun suhteeni yhteisöihin?',
          'Mitkä ovat minun toiveeni?',
          'Miten näen tulevaisuuden?',
          'Miten koen ystävyyssuhteet?'
        ]
      }
    },
    { 
      number: 12, 
      name: 'Alitajunta / Päästä irti', 
      description: 'Liittyy alitajuntaan, piilotettuihin asioihin, henkisyyteen ja päästämiseen irti.',
      detailedContent: {
        keywords: ['Alitajunta', 'Piilotetut asiat', 'Henkisyys', 'Päästä irti', 'Sielu', 'Mysteerit', 'Yksinäisyys', 'Healing'],
        theme: '12. huone liittyy alitajuntaan, piilotettuihin asioihin, henkisyyteen ja päästämiseen irti. Se kertoo, miten koet alitajunnan, mitä piilotettuja asioita sinulla on ja miten päästät irti. Tämä huone myös paljastaa suhteesi henkisyyteen ja mysteereihin.',
        whenEmphasized: [
          'Alitajunta ja henkisyys ovat keskeisiä elämässäsi',
          'Piilotetut asiat vaikuttavat sinuun',
          'Olet kiinnostunut mysteereistä ja sielusta',
          'Päästäminen irti on tärkeää',
          'Yksinäisyys ja healing ovat osa elämääsi'
        ],
        challenges: [
          'Tendenssi pakenea todellisuutta',
          'Vaikeus käsitellä alitajuntaa',
          'Yli-henkisyys ja vaikeus olla käytännöllinen',
          'Vaikeus päästää irti menneestä',
          'Tendenssi olla liian yksinäinen'
        ],
        practicalTips: [
          'Tutki alitajuntaasi, mutta älä anna sen määritellä sinua',
          'Päästä irti menneestä, mutta muista myös oppia siitä',
          'Käytä henkisyyttä rakentavasti, mutta pysy myös maanläheisenä'
        ],
        selfReflection: [
          'Mikä on minun suhteeni alitajuntaan?',
          'Mitkä piilotetut asiat vaikuttavat minuun?',
          'Miten päästän irti?',
          'Mikä on minun suhteeni henkisyyteen?'
        ]
      }
    }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    const tocElement = document.querySelector('.astrology-toc');
    if (element) {
      const navbarHeight = 80; // Navbar height
      const tocHeight = tocElement ? tocElement.offsetHeight : 0;
      const offset = navbarHeight + tocHeight + 20; // Navbar + TOC + extra spacing
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="astrology-page">
      {/* Hero */}
      <section id="astrology-hero" className="astrology-hero">
        <div className="container">
          <h1>Astrologia</h1>
          <p className="astrology-intro">
            Astrologia on muinainen symbolinen järjestelmä, joka tutkii planeettojen ja tähtien vaikutusta ihmiselämään. 
            Se tarjoaa työkalun itsetuntemukseen, henkilökohtaiseen kasvuun ja elämän ymmärtämiseen. 
            Tämä oppaassa tutustut astrologian peruskäsitteisiin, aurinkomerkkeihin ja astrologisiin huoneisiin.
          </p>
        </div>
      </section>

      {/* Sisällysluettelo */}
      <section className="astrology-toc">
        <div className="container">
          <h2 className="toc-title">Sisällysluettelo</h2>
          <nav className="toc-nav">
            <button className="toc-link" onClick={() => scrollToSection('kasite-aurinkomerkki')}>
              Aurinkomerkki
            </button>
            <button className="toc-link" onClick={() => scrollToSection('kasite-kuumerkki')}>
              Kuumerkki
            </button>
            <button className="toc-link" onClick={() => scrollToSection('kasite-nousumerkki')}>
              Nousumerkki
            </button>
            <button className="toc-link" onClick={() => scrollToSection('kasite-planeetat')}>
              Planeetat
            </button>
            <button className="toc-link" onClick={() => scrollToSection('kasite-elementit')}>
              Elementit & modaliteetit
            </button>
            <button className="toc-link" onClick={() => scrollToSection('kasite-aspektit')}>
              Aspektit
            </button>
            <button className="toc-link" onClick={() => scrollToSection('kasite-syntymakartta')}>
              Syntymäkartta
            </button>
            <button className="toc-link" onClick={() => scrollToSection('huoneet')}>
              Huoneet
            </button>
          </nav>
        </div>
      </section>

      {/* Aurinkomerkit */}
      <section id="aurinkomerkit" className="astrology-section astrology-signs">
        <div className="container">
          <h2>Aurinkomerkkihoroskooppi</h2>
          <div className="astrology-grid signs-grid">
            {zodiacSigns.map((sign) => (
              <div 
                key={sign.id} 
                id={`sign-${sign.id}`}
                className={`sign-card ${expandedSign === sign.id ? 'expanded' : ''}`}
              >
                <div className="sign-header">
                  <span className="sign-symbol">{sign.symbol}</span>
                  <h3>{sign.name}</h3>
                  <p className="sign-dates">{sign.dates}</p>
                  <div className="sign-badges">
                    <span className="badge badge-element">{sign.element}</span>
                    <span className="badge badge-modality">{sign.modality}</span>
                  </div>
                </div>
                
                <div className="sign-core">
                  <p>{sign.inLife}</p>
                </div>

                <div className={`sign-content ${expandedSign === sign.id ? 'visible' : 'hidden'}`}>
                  <div className="sign-section two-column">
                    <div>
                      <h4>Vahvuudet</h4>
                      <ul>
                        {sign.strengths.map((strength, idx) => (
                          <li key={idx}>{strength}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4>Haasteet</h4>
                      <ul>
                        {sign.challenges.map((challenge, idx) => (
                          <li key={idx}>{challenge}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="sign-section">
                    <h4>Käytännössä</h4>
                    <p>{sign.suitableFor}</p>
                  </div>

                  <div className="sign-section highlight-box">
                    <h4>Kasvun suunta</h4>
                    <p>Merkkisi opettaa sinua käyttämään energiaasi rakentavasti ja löytämään tasapainoa impulsiivisuuden ja harkitsevaisuuden välillä.</p>
                  </div>
                </div>

                <button 
                  className="sign-expand-btn"
                  onClick={() => setExpandedSign(expandedSign === sign.id ? null : sign.id)}
                >
                  {expandedSign === sign.id ? 'Näytä vähemmän' : 'Lue lisää'}
                </button>
              </div>
            ))}
          </div>
          <div className="back-to-top">
            <button onClick={() => scrollToSection('astrology-hero')}>Takaisin ylös ↑</button>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      {/* Astrologiset käsitteet - yksittäiset osiot */}
      {basicConcepts.map((concept) => {
        const conceptIdMap = {
          'sun-sign': 'kasite-aurinkomerkki',
          'moon-sign': 'kasite-kuumerkki',
          'rising-sign': 'kasite-nousumerkki',
          'planets': 'kasite-planeetat',
          'elements': 'kasite-elementit',
          'aspects': 'kasite-aspektit',
          'natal-chart': 'kasite-syntymakartta'
        };
        return (
          <section key={concept.id} id={conceptIdMap[concept.id]} className="astrology-section astrology-concept-section">
            <div className="container">
              <h2>{concept.term}</h2>
              <div className="concept-content">
                {typeof concept.description === 'string' ? (
                  <p>{concept.description}</p>
                ) : (
                  concept.description
                )}
              </div>
              <div className="back-to-top">
                <button onClick={() => scrollToSection('astrology-hero')}>Takaisin ylös ↑</button>
              </div>
            </div>
          </section>
        );
      })}

      <div className="divider"></div>

      {/* Huoneet */}
      <section id="huoneet" className="astrology-section astrology-houses">
        <div className="container">
          <h2>Astrologiset Huoneet</h2>
          <div className="concept-content">
            <p><strong>Mitä huone kertoo:</strong> Huone kertoo <em>missä</em> elämässäsi eri energiat ilmenevät. Kun planeetta on tietyssä huoneessa, se kertoo, millä elämänalueella sen energia näkyy. Esimerkiksi Mars 7. huoneessa näkyy suhteissa ja konflikteissa, kun taas Mars 10. huoneessa näkyy uralla ja julkisessa kuvassa.</p>
            <p><strong>Ero: merkki = tyyli, planeetta = toiminto, huone = missä se tapahtuu:</strong> <strong>Merkki</strong> kertoo <em>miten</em> energia ilmenee (tyyli). Esimerkiksi Venus Vaakassa on diplomaattinen ja tasapainoinen. <strong>Planeetta</strong> kertoo <em>mitä</em> energiaa on kyseessä (toiminto). Esimerkiksi Venus on rakkaus ja kauneus. <strong>Huone</strong> kertoo <em>missä</em> elämässäsi tämä energia näkyy (elämänalue). Esimerkiksi Venus 7. huoneessa näkyy suhteissa. Yhdessä nämä kolme antavat täyden kuvan: Venus (rakkaus) Vaakassa (diplomaattisesti) 7. huoneessa (suhteissa) = etsit diplomaattista ja tasapainoista rakkautta suhteissa.</p>
            <p className="houses-intro">
              Astrologiset huoneet jakavat syntymäkartan 12 osaan, joista jokainen edustaa eri elämänaluetta. 
              Huoneet kertovat, missä elämässäsi eri planeettojen energiat ilmenevät. Kun planeetta on tietyssä huoneessa, 
              se kertoo millä elämänalueella sen energia näkyy vahvimmin.
            </p>
          </div>
          
          {/* Pikaopas */}
          <div className="houses-quick-guide">
            <h3>Pikaopas</h3>
            <div className="astrology-grid houses-grid">
              {houses.map((house) => (
                <div key={house.number} className="house-card-quick">
                  <div className="house-number">{house.number}</div>
                  <h4>{house.name}</h4>
                  <p>{house.description}</p>
                  {house.detailedContent && (
                    <div className="house-keywords-preview">
                      {house.detailedContent.keywords.slice(0, 3).map((keyword, idx) => (
                        <span key={idx} className="keyword-tag-small">{keyword}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="back-to-top">
            <button onClick={() => scrollToSection('astrology-hero')}>Takaisin ylös ↑</button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="astrology-cta">
        <div className="container">
          <h2>Haluatko tulkinnan omasta kartastasi?</h2>
          <p>
            Laske henkilökohtainen syntymäkarttasi ja saa yksityiskohtaiset tulkinnat 
            planeettojesi sijainneista, huoneista ja aspekteista.
          </p>
          <div className="cta-buttons">
            <Link to="/register" className="btn btn-primary btn-large">
              Rekisteröidy ilmaiseksi
            </Link>
            <Link to="/charts" className="btn btn-secondary btn-large">
              Katso esimerkkejä
            </Link>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="astrology-disclaimer">
        <div className="container">
          <p className="disclaimer-text">
            <strong>Huomio:</strong> Astrologia on symbolinen työkalu itsetuntemukseen ja henkilökohtaiseen 
            kasvuun. Se ei korvaa ammattilaisneuvoja, terapeuttia tai lääkäriä. Astrologiset tulkinnat 
            ovat ohjeellisia ja eivät määritä kohtaloasi.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Astrology;
